import React from "react";
import "../css/AudioSlider.css"; 

const AudioSlider = ({ label, value, onChange, id }) => {
  return (
    <div className="flex flex-col items-center">
      <label
        htmlFor={id}
        className="mb-1 text-xs font-medium text-gray-700 gazette-title"
      >
        {label}
      </label>
      <input
        type="range"
        id={id}
        min="0"
        max="100"
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default AudioSlider;
